<script>
import { certDetail, certList } from '@/api/demo/close'
import Image from '@/pages/demo/configuration/templateDialog/image.vue'
export default {
  name: 'PositionSelection',
  components: { Image },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      positionList: [],
      //   当前选择的岗位
      position: {},
      positionId: '',
      dialogVisible: false
    }
  },
  watch: {
    value: {
      handler: function (val, oldVal) {
        this.positionId = val
        this.getPositionDetail()
      }
    }
  },
  created () {
    this.positionId = this.value
    this.getPositionList()
    this.getPositionDetail()
  },
  methods: {
    async getPositionList () {
      console.log('getPositionList >>')
      certList({ pageSize: 100, currentPage: 1 }).then(res => {
        this.positionList = res.records
      })
    },
    async getPositionDetail () {
      if (!this.value) {
        return
      }
      certDetail(this.value).then(res => {
        this.position = res
      })
    },
    selected (id) {
      this.positionId = id
      this.$emit('input', id)
      this.dialogVisible = false
    },
    handleClose (done) {
      done()
    },
    showSelector () {
      this.dialogVisible = true
    }
  }
}

</script>

<template>
  <div>
    <div @click="showSelector" class="position">
      <!--   显示已选择的岗位 包含头像和岗位名称 -->
      <el-image :src="position.icon" alt="选择" style="width: 30px;height: 30px;border-radius: 50%;margin-right: 10px;">
        <div slot="error" class="image-error"
          style="width: 30px;height: 30px;border-radius: 50%;
        font-size: 12px;display: flex;align-items: center;justify-content: center; text-decoration: underline;color: #6950a1;">
          选择
        </div>
      </el-image>
      <span>{{ position.name }}</span>
    </div>
    <!-- 弹窗选择岗位 -->
    <el-dialog title="选择岗位" append-to-body :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <!--  显示所有岗位 上面显示头像 下方显示名称 -->
      <div>
        <el-row>
          <el-col :span="12" v-for="item in positionList" :key="item.id">
            <div :class="{ 'position-item': true, 'selected': item.id === positionId }" @click="selected(item.id)">
              <img :src="item.icon" alt="">
              <span>{{ item.name }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.position {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.position el-image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.position-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.position-item img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.selected {

  color: red;
}
</style>
